import createAction from 'helpers/createAction';

export const toggleTheme = createAction('TOGGLE_THEME');
